
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Classification_of_medial_epicondyle_fractures_of_the_humerus',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Classification_of_medial_epicondyle_fractures_of_the_humerus.vue